import { render } from "./SelectInventoryDocument.vue?vue&type=template&id=d2ffdb18&scoped=true"
import script from "./SelectInventoryDocument.vue?vue&type=script&lang=js"
export * from "./SelectInventoryDocument.vue?vue&type=script&lang=js"

import "./SelectInventoryDocument.vue?vue&type=style&index=0&id=d2ffdb18&scoped=true&lang=css"
import "./SelectInventoryDocument.vue?vue&type=style&index=1&id=d2ffdb18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ffdb18"]])

export default __exports__